import { useParams } from 'wouter'
import { useCallback, useState } from 'react'
import { Trans } from '@lingui/react/macro'

import * as Form from '@/features/form'
import { useAuth } from '../hooks/useAuth'
import { useErrorToText } from '../hooks/useErrorCode'
import { PasswordField } from './PasswordField'

type FormData = {
  password: string
  confirmPassword: string
}

export default function ResetPasswordForm() {
  const { client, changePassword } = useAuth()
  const { code } = useParams() as { code: string }
  const getError = useErrorToText()

  const [serverError, setServerError] = useState<Form.ServerError>()

  const submit = useCallback(
    async (data: FormData) => {
      await changePassword(code, data.password)

      const error = client.getError()

      if (error) {
        setServerError({
          message: getError(error.errorCode),
          type: error.errorCode
        })
      }
    },
    [client, code, changePassword, setServerError, getError]
  )

  return (
    <Form.Root
      onSubmit={submit}
      serverErrors={
        serverError
          ? {
              root: { serverError }
            }
          : undefined
      }
      defaultValues={{
        password: '',
        confirmPassword: ''
      }}
    >
      <div className="flex flex-col gap-2.5">
        <h1 className="text-text text-heading1 text-center">
          <Trans>Change password</Trans>
        </h1>
        <PasswordField />
        <div className="text-center">
          <Form.Error name="root.serverError" />
        </div>
        <div className="flex flex-row justify-end">
          <Form.Submit>
            <Trans>Submit</Trans>
          </Form.Submit>
        </div>
      </div>
    </Form.Root>
  )
}
